var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPricing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 62,
    viewBox: "0 0 63 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8363 9.54395L35.3816 15.2598C40.4999 20.5368 35.9805 31.0014 30.0104 37.1552C23.8961 43.4564 13.8103 47.8976 8.76407 42.6961L3.21875 36.9802",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1154 12.3477L23.9424 15.6183",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12129 30.8965L5.90723 34.2094",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33675 23.5177C8.31863 24.4597 7.6543 25.7229 7.6543 27.2433C7.6543 30.0841 9.88906 32.4071 12.6451 32.4071C15.4011 32.4071 17.6359 30.0841 17.6359 27.2433C17.6359 26.6123 17.5261 26.0076 17.3242 25.4485L15.7305 21.0359C15.5275 20.4769 15.4177 19.8721 15.4177 19.2411C15.4177 16.4003 17.6525 14.1162 20.4085 14.1162C23.1645 14.1162 25.3993 16.4003 25.3993 19.2411C25.3993 20.7627 24.7594 22.1288 23.7413 23.0707",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4153 26.0195C52.4316 32.4316 59.0716 46.8563 53.1259 52.9848C47.88 58.3921 36.1306 53.7428 29.0947 44.2281",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.915 32.9248C59.1563 36.4584 60.592 40.023 61.1675 43.3553M61.3916 48.01C61.326 48.7449 61.2087 49.4589 61.0391 50.1481",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43652 9.01758C9.32202 6.02139 12.4049 3.8308 15.4467 2.55585M19.8165 1.35946C20.5275 1.27236 21.2294 1.2417 21.9188 1.26903",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1256 52.9843L47.5802 58.7001C41.8275 64.6298 28.5354 58.4304 22.0186 47.665",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4216 50.196L47.2197 46.8945",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4727 39.7349C34.1947 40.159 35.0287 40.4094 35.917 40.4094C36.5292 40.4094 37.1159 40.2757 37.6583 40.0676L41.9392 38.4248C42.4816 38.2168 43.0683 38.123 43.6805 38.123C46.4365 38.123 48.6901 40.4071 48.6901 43.2479C48.6901 46.0887 46.4365 48.4117 43.6805 48.4117C42.2043 48.4117 40.879 47.7315 39.9651 46.6832",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0322 58.1289L18.0322 60.5786",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0322 48.3301L18.0322 53.2294",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8203 25.0617L48.8203 20.4043",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M3.21819 36.9801C1.71874 35.4322 1.00783 33.2979 1.00007 30.8618C0.984539 26.0342 3.72947 20.021 8.56499 15.0299C12.5243 10.9431 18.4068 7.19572 23.9732 7.25859C26.1858 7.28374 28.2886 7.94793 29.8357 9.54495C31.3296 11.0871 32.0405 13.2066 32.0538 15.6255C32.0805 20.4486 29.3355 26.464 24.4889 31.4666C19.6623 36.4485 13.9096 39.2287 9.28144 39.2665C6.85148 39.2859 4.73206 38.5417 3.21819 36.9801V36.9801Z",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8203 15.7464L48.8203 14.582",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8203 9.92509L48.8203 8.76074",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricing);
export default __webpack_public_path__ + "static/media/pricing.1433823b09faf59a0a0017da70a45358.svg";
export { ForwardRef as ReactComponent };